// extracted by mini-css-extract-plugin
module.exports = {"runline_title":"style_runline_title__o7DTr","runline_wrap":"style_runline_wrap__26qNH","ticker":"style_ticker__FbWL1","runline_wrap_second":"style_runline_wrap_second__rZ3wl"};